// Cross-origin POST to admin form-intake. NOT a same-origin helper —
// do NOT route through apps/storefront/src/lib/api.ts (which is same-origin only).

export type SubmitResult =
  | { ok: true; id: string }
  | { ok: false; errorCode: string; detail?: string | string[] };

type Endpoint = '/api/forms/contact' | '/api/forms/applications';

export async function submitForm<T extends Record<string, unknown>>(args: {
  endpoint: Endpoint;
  payload: T;
  token: string;
}): Promise<SubmitResult> {
  const base = process.env.NEXT_PUBLIC_ADMIN_API_BASE_URL ?? 'http://localhost:3001';
  const url = `${base}${args.endpoint}`;

  let res: Response;
  try {
    res = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...args.payload, 'cf-turnstile-response': args.token }),
    });
  } catch {
    return { ok: false, errorCode: 'network-failed' };
  }

  let body: unknown;
  try {
    body = await res.json();
  } catch {
    return { ok: false, errorCode: 'network-failed' };
  }

  if (
    res.ok &&
    typeof body === 'object' &&
    body !== null &&
    'ok' in body &&
    (body as { ok: boolean }).ok === true &&
    'id' in body &&
    typeof (body as { id: unknown }).id === 'string'
  ) {
    return { ok: true, id: (body as { id: string }).id };
  }

  if (typeof body === 'object' && body !== null && 'error' in body) {
    const b = body as { error: string; detail?: string | string[] };
    return { ok: false, errorCode: b.error, detail: b.detail };
  }

  return { ok: false, errorCode: 'network-failed' };
}
